import config from 'crm/config'

const profileApi = `${config.apiHost}/oem-profile`

export default {
    // 获取朋友圈参数-列表
    getMomentsParamsList: {
        url: `${profileApi}/api/moments/configs`,
        type: 'GET',
    },

    // 批量-设置朋友圈参数
    editMomentsParams: {
        url: `${profileApi}/api/moments/configs`,
        type: 'POST',
    },
}
